module.exports = __webpack_public_path__ + "static/4-a91bbb6ba97e79c66130c167ab4b21c6.jpeg";